import { DialogHeader, DialogTitle } from "@/view/components/ui/dialog";

import { Button } from "@/view/components/ui/button";
import { ChevronLeft } from "lucide-react";

interface HeaderProps {
  title: string;
  onBack?: () => void;
}
export default function Header({ title, onBack }: HeaderProps) {
  return (
    <DialogHeader className="border-b border-gray01 pb-4">
      <div className="flex items-center gap-2">
        {onBack && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="-ml-2 h-8 w-8 text-black01"
            type="button"
          >
            <ChevronLeft className="h-6 w-6" />
          </Button>
        )}
        <DialogTitle className="text-xl font-semibold text-black01">
          {title}
        </DialogTitle>
      </div>
    </DialogHeader>
  );
}
